import React from 'react';
import { Check, X } from 'lucide-react';
export function ForWhomSection() {
  const forList = ['Men 50+ who are dating again and feel the pressure', 'Men who want a solution this week, not six months of therapy', 'Men who understand the problem is mental, not physical'];
  const notForList = ['Those seeking a medical diagnosis', 'Those expecting guaranteed results from a PDF', 'Those looking for a magic pill'];
  return <section className="py-20 md:py-24 px-4 sm:px-6 bg-dark-card/30 border-y border-dark-border" data-id="element-112">
      <div className="max-w-5xl mx-auto" data-id="element-113">
        <h2 className="text-3xl md:text-4xl font-bold mb-16 text-center text-text-primary" data-id="element-114">
          Who It's For (And Who It's Not)
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-115">
          {/* FOR */}
          <div className="bg-dark-bg p-8 rounded-xl border border-dark-border h-full" data-id="element-116">
            <h3 className="text-2xl font-bold text-text-primary mb-8 flex items-center gap-3" data-id="element-117">
              <span className="bg-green-500/20 text-green-500 p-2 rounded-lg" data-id="element-118">
                <Check className="w-6 h-6" data-id="element-119" />
              </span>
              FOR
            </h3>
            <ul className="space-y-6" data-id="element-120">
              {forList.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-121">
                  <Check className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-122" />
                  <span className="text-text-secondary text-lg" data-id="element-123">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* NOT FOR */}
          <div className="bg-dark-bg p-8 rounded-xl border border-dark-border h-full" data-id="element-124">
            <h3 className="text-2xl font-bold text-text-primary mb-8 flex items-center gap-3" data-id="element-125">
              <span className="bg-red-500/20 text-red-500 p-2 rounded-lg" data-id="element-126">
                <X className="w-6 h-6" data-id="element-127" />
              </span>
              NOT FOR
            </h3>
            <ul className="space-y-6" data-id="element-128">
              {notForList.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-129">
                  <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-130" />
                  <span className="text-text-secondary text-lg" data-id="element-131">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}